// Skeleton — a shimmering placeholder for loading content. Token-driven,
// respects prefers-reduced-motion (holds still). Compose a few to sketch a
// card while its query resolves.
//
//   <Skeleton width="60%" />
//   <Skeleton variant="circle" width={40} height={40} />
//   <SkeletonText lines={3} />

import { CSSProperties } from 'react';

export interface SkeletonProps {
  variant?: 'text' | 'block' | 'circle';
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  className?: string;
  style?: CSSProperties;
}

export default function Skeleton({ variant = 'block', width, height, radius, className, style }: SkeletonProps) {
  const cls = ['ui-skeleton', variant === 'text' ? 'ui-skeleton--text' : '', variant === 'circle' ? 'ui-skeleton--circle' : '', className]
    .filter(Boolean)
    .join(' ');
  return (
    <span
      className={cls}
      aria-hidden
      style={{
        width: width ?? (variant === 'text' ? '100%' : undefined),
        height: height ?? (variant === 'block' ? 16 : undefined),
        borderRadius: radius,
        ...style,
      }}
    />
  );
}

/** A stack of text lines (last line shorter, like real paragraphs). */
export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={className} role="status" aria-label="Loading" style={{ display: 'grid', gap: 6 }}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} variant="text" width={i === lines - 1 ? '55%' : '100%'} />
      ))}
    </div>
  );
}
